import * as requestFromServer from "./mergingListCrud";
import { mergingListSlice, callTypes } from "./mergingListSlice";
import { actions as auth } from "../../Auth/_redux/authRedux";
import { toastOption } from "../../../../_metronic/_helpers/ToastHelpers";
import { toast } from "react-toastify";

const { actions } = mergingListSlice;

export const fetchMergingLists = (queryParams) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.list }));
  return requestFromServer
    .findMergingList(queryParams)
    .then((response) => {
      const {
        data: { total_items, items },
      } = response.data;
      dispatch(actions.mergingListsFetched({ total_items, items }));
    })
    .catch((error) => {
      if (error.response.status === 401) {
        toast.error(error.response.data.message, toastOption);
        dispatch(auth.logout());
      }
      error = error.response.data.message;
      dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
};

export const fetchMergingList = (id) => (dispatch) => {
  if (!id) {
    return dispatch(
      actions.mergingListFetched({ mergingListForEdit: undefined })
    );
  }

  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .getMergingListById(id)
    .then((response) => {
      const { data: mergingList } = response.data; // alias data -> donatur
      dispatch(actions.mergingListFetched({ mergingListForEdit: mergingList }));
    })
    .catch((error) => {
      if (error.response.status === 401) {
        toast.error(error.response.data.message, toastOption);
        dispatch(auth.logout());
      }
      error = error.response.data.message;
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const createMergingList = (mergingListForCreation) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .createMergingList(mergingListForCreation)
    .then((response) => {
      dispatch(actions.mergingListReload);
      return response.data;
    })
    .catch((error) => {
      if (error.response.status === 401) {
        toast.error(error.response.data.message, toastOption);
        dispatch(auth.logout());
      }
      error = error.response.data.message;
      dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
};

export const updateMergingList = (mergingList) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .updateMergingList(mergingList)
    .then((response) => {
      dispatch(actions.mergingListReload);
      return response.data;
    })
    .catch((error) => {
      if (error.response.status === 401) {
        toast.error(error.response.data.message, toastOption);
        dispatch(auth.logout());
      }
      error = error.response.data.message;
      dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
};

export const deleteMergingList = (uuid) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .deleteMergingList(uuid)
    .then((response) => {
      dispatch(actions.mergingListReload);
      return response.data;
    })
    .catch((error) => {
      if (error.response.status === 401) {
        toast.error(error.response.data.message, toastOption);
        dispatch(auth.logout());
      }
      error = error.response.data.message;
      dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
};

export const saveMergingList = (params) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .saveMerging(params)
    .then((response) => {
      dispatch(actions.mergingListReload);
      return response.data;
    })
    .catch((error) => {
      if (error.response.status === 401) {
        toast.error(error.response.data.message, toastOption);
        dispatch(auth.logout());
      }
      error = error.response.data.message;
      dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
};
